/**
 * Created by Ivan on 18.01.2023
 */

const EditorFogHead = function (tile, block) {
    this.tile = tile;
    this.block = block;

    this.moveTo = function () {};
    this.onDragMove = function () {};
    this.onUpdateTitle = function () {};
};

EditorFogHead.prototype.handleDragEnd = function (cell) {
    if (!this.canMoveTo(cell.x, cell.y)) {
        cell = this.tile;
    }

    this.setPosition(cell);
};

EditorFogHead.prototype.canMoveTo = function (x, y) {
    const tile = this.block.findTile(x, y);
    return tile && tile !== this.block.balloonTile;
};

EditorFogHead.prototype.setPosition = function (x, y) {
    Editor.currentEditor.doCommand("moveFogHead", {
        x, y, code: this.block.id
    });
};

EditorFogHead.prototype.getShape = function () {
    return FamiliesHelper.ShapeCell;
};